import React from 'react';

const AppointmentContext = React.createContext();

export default AppointmentContext;
